import LocalAsyncStore from '../../../local-async-store'
import CCSRegoView from './views'

export const apiEndPoint = ({ type, type_id }) => `/api/${type}s/${type_id}/service-registrations`

export default LocalAsyncStore('service_registrations', CCSRegoView, apiEndPoint)



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/index.js